import React, { useState } from 'react'
import { FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material'
import { useSelector } from 'react-redux';

import './justificado.css'
import { Model } from '../../../models/model'

export const JustificadoForm = ({ setModal, dataCompra, checkInitialData, initGetAllPayByGasto }) => {

    const { listaTiposDocumentos } = useSelector(state => state.general)
    const [msgError, setMsgError] = useState('')
    const [form, setForm] = useState(dataCompra)

    const handleChange = ({ target }) => {
        setForm({
            ...form,
            [target.name]: target.value
        });
    }

    const handleSave = async () => {

        if (form.nro_doc_justificacion === null || form.nro_doc_justificacion === '') {
            setMsgError('Ingrese nro. doc')
            return false
        }

        await Model.update({
            url: `compras/justificar/${form.id}`,
            dataForm: form
        })

        await checkInitialData(form.id)
        setModal(false)

    }

    return (
        <div className="row p-payments-form" style={{ width: '400px' }}>
            <div className="col">

                <div className="row">
                    <div className="col">
                        <FormControl fullWidth size="small">
                            <InputLabel id="demo-simple-select-label">Tipo de documento</InputLabel>
                            <Select
                                label="Tipo de documento"
                                id="id_tipo_documento"
                                name="id_tipo_documento"
                                value={form.id_tipo_documento || ''}
                                onChange={handleChange}
                                className='p-list-capitalize'
                                disabled={true}
                            >
                                <MenuItem value='' key=''>Ninguno</MenuItem>
                                {listaTiposDocumentos.map(item => (
                                    <MenuItem value={item.id} key={item.id} className='p-list-capitalize'>{item.nombre}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </div>
                </div>

                <div className="row">
                    <div className="col">
                        <TextField
                            label="Número del documento (obligatorio)"
                            name="nro_doc_justificacion"
                            id="outlined-size-small"
                            value={form.nro_doc_justificacion || ''}
                            size="small"
                            fullWidth
                            placeholder='Ingrese Nro. de documento'
                            onChange={handleChange}
                            disabled={form.reading_mode}
                        />
                    </div>
                </div>

                <div className="row">
                    <div className="col ">
                        <div style={{ fontSize: '14px' }}>Adjunta enlace al documento (opcional)</div>
                        <div style={{ fontSize: '14px', color: 'gray' }}>Te facilita el seguimiento para futuras revisiones.</div>
                        <div className='mt-2'>
                            <input
                                type="url"
                                style={{
                                    width: '100%',
                                    border: '0px',
                                    borderBottom: '1px solid lightgray',
                                    padding: '5px',
                                    fontSize: '13px',
                                    outline: 'none'
                                }}
                                onChange={handleChange}
                                placeholder='Ingrese enlace del archivo'
                                name="url_doc_justificacion"
                                value={form?.url_doc_justificacion || ''}
                                disabled={form.reading_mode}
                            />
                        </div>
                    </div>
                </div>

                {msgError !== '' &&
                    <div className='mt-2' style={{ color: 'red' }}>{msgError}</div>
                }

                <div className="row">
                    <div className="col text-end">
                        <button className='btn' onClick={handleSave}>
                            <label>Guardar</label>
                        </button>
                    </div>
                </div>


            </div>
        </div>
    )

}